import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const UseresUrl = `${Base_Url}/Notification`;

export const GetAdminNotificationList = async (params) => {
  const res = await postApiWithAuthorization(
    `${UseresUrl}/GetAdminNotificationList`,
    params
  );
  return res;
};
